/**
 * Collection / search results grid — Alpine component + optional quick-view store.
 * Extracted from sections/results-page.liquid.
 *
 * Configuration is read from the #collectionGrid root via data-* attributes:
 *   data-sort-by, data-default-sort-by, data-enable-ajax, data-money-format,
 *   data-product-quick-view, data-root-url.
 */
document.addEventListener('alpine:init', () => {
  Alpine.data('results', () => ({
    loading: false,
    paginationLoading: false,
    showMobileFilters: false,
    showHorizontalFilters: false,
    sortBy: '',
    defaultSortBy: '',
    enableAjax: false,
    moneyFormatString: '',
    minprice: 1,
    maxprice: 1,
    minthumb: 0,
    maxthumb: 0,
    page: 1,
    totalPages: 1,
    lowestLoadedPage: null,
    highestLoadedPage: null,

    init() {
      const d = this.$el.dataset;
      this.sortBy = d.sortBy || '';
      this.defaultSortBy = d.defaultSortBy || '';
      this.enableAjax = d.enableAjax === 'true';
      this.moneyFormatString = d.moneyFormat || '';
    },

    scrollToTop() {
      window.scrollTo({ top: '0', behavior: 'instant' });
    },

    onPopStateHandler(event) {
      this.fetchResults(event.target.location, false);
    },

    moneyFormat() {
      return this.moneyFormatString.replace(/\{\{(.*?)\}\}/, '{{ amount_no_decimals }}');
    },

    updatePageConfig(page, totalPages) {
      this.page = page;
      this.totalPages = totalPages;
      this.lowestLoadedPage = this.lowestLoadedPage ? Math.min(this.lowestLoadedPage, page) : page;
      this.highestLoadedPage = this.highestLoadedPage ? Math.max(this.highestLoadedPage, page) : page;
    },

    updateSorting(value) {
      if (value === this.sortBy) return;

      this.sortBy = value;

      const params = new URLSearchParams(window.location.search);

      params.set('sort_by', this.sortBy);
      params.delete('page');

      if (!this.enableAjax) return (window.location.search = params.toString());

      const url = new URL(window.location);

      url.search = params.toString();

      this.fetchResults(url, true);
    },

    updatePage(url) {
      this.updateFilter(url);
      this.scrollToTop();
    },

    updateFilter(url, collapseFilters = false) {
      if (!url) return;
      if (!this.enableAjax) return (window.location = url);
      this.fetchResults(url, true, 'replace', collapseFilters);
    },

    clearFilters(url) {
      this.updateFilter(url, true);
    },

    updatePriceFilter(isEnter) {
      const activeId = document.activeElement.id;
      if ((activeId.includes('GTE') || activeId.includes('LTE')) && !isEnter) return;

      const params = new URLSearchParams(window.location.search);
      params.set('filter.v.price.gte', this.minprice);
      params.set('filter.v.price.lte', this.maxprice);
      params.delete('page');

      if (!this.enableAjax) return (window.location.search = params.toString());

      const url = new URL(window.location);

      url.search = params.toString();

      this.fetchResults(url, true);
    },

    loadPrevious(url) {
      this.paginationLoading = true;
      this.fetchResults(this.replacePageNumber(url, Math.max(this.lowestLoadedPage - 1, 1)), true, 'prepend');
    },

    loadNext(url) {
      this.paginationLoading = true;
      this.fetchResults(
        this.replacePageNumber(url, Math.min(this.highestLoadedPage + 1, this.totalPages)),
        true,
        'append',
      );
    },

    replacePageNumber(url, page) {
      const updatedUrl = new URL(url, window.location.origin);
      const params = new URLSearchParams(updatedUrl.search);

      params.set('page', page);

      updatedUrl.search = params.toString();

      return updatedUrl;
    },

    fetchResults(url, pushState, mode = 'replace', collapseFilters = false) {
      if (!this.enableAjax) return (window.location = url);

      this.loading = true;

      const fetchUrl = new URL(url, window.location.origin);
      const params = new URLSearchParams(fetchUrl.search);

      params.set('section_id', 'results');

      fetch(fetchUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          if (!html) {
            this.loading = false;
            this.paginationLoading = true;
            return;
          }

          switch (mode) {
            case 'replace':
              updateHtml('replace');
              break;
            case 'append':
              updateHtml('append');
              break;
            case 'prepend':
              updateHtml('prepend');
              break;
            default:
              updateHtml('replace');
          }

          function updateHtml(mode = 'replace') {
            let resultsListHtml = '';
            const resultsListTarget = document.getElementById('resultsList');
            const resultsListTargetHtml = resultsListTarget.innerHTML;
            const resultsListSourceHtml = html.getElementById('resultsList').innerHTML;

            if (mode === 'prepend') {
              resultsListHtml = resultsListSourceHtml + resultsListTargetHtml;
            } else if (mode === 'append') {
              resultsListHtml = resultsListTargetHtml + resultsListSourceHtml;
            }

            document.getElementById('results').innerHTML = html.getElementById('results').innerHTML;

            if (resultsListHtml) {
              document.getElementById('resultsList').innerHTML = resultsListHtml;
            }
          }

          if (collapseFilters) this.showHorizontalFilters = false;
          this.loading = false;
          this.paginationLoading = false;

          if (pushState) window.history.pushState({}, '', url.toString());
        })
        .catch((error) => {
          this.handleError(error);
        });
    },

    handleError(message) {
      // eslint-disable-next-line no-console
      console.error(message);
      this.loading = false;
    },
  }));

  const grid = document.getElementById('collectionGrid');

  if (grid && grid.dataset.productQuickView === 'true') {
    Alpine.store('productModal', {
      loadingHandles: {},

      loadProduct(handle) {
        this.loadingHandles[handle] = true;
        const rootUrl = document.getElementById('collectionGrid')?.dataset.rootUrl || '';
        fetch(`${rootUrl}products/${handle}?view=quick-buy`)
          .then((res) => res.text())
          .then((html) => {
            const parser = new DOMParser();
            const parsedContent = parser.parseFromString(html, 'text/html');
            document.body.appendChild(parsedContent.querySelector('[data-quickbuy]'));
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.error(err);
          })
          .finally(() => {
            delete this.loadingHandles[handle];
          });
      },

      close() {
        const modal = document.querySelector('[data-quickbuy]');
        if (modal) modal.remove();
      },

      isLoading(handle) {
        return !!this.loadingHandles[handle];
      },
    });
  }
});
